import React from "react";
import { string, number } from "prop-types";

export function Search({ color = "#d0021b", width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <g fill="none" data-name="Union 2">
        <path d="M16.933 20.186l-3.811-3.811a1.8 1.8 0 0 1-.494-1.607 8.045 8.045 0 0 1-4.545 1.4A8.084 8.084 0 0 1 0 8.083 8.084 8.084 0 0 1 8.083 0a8.083 8.083 0 0 1 8.083 8.083 8.052 8.052 0 0 1-1.921 5.232 1.794 1.794 0 0 1 1.418.52l3.811 3.811a1.8 1.8 0 0 1 0 2.541 1.792 1.792 0 0 1-1.271.526 1.79 1.79 0 0 1-1.27-.527z" />
        <path
          fill={color}
          d="M8.083 13.167a5.051 5.051 0 0 0 2.856-.878l.572-.389.448-.528A5.084 5.084 0 0 0 8.083 3 5.09 5.09 0 0 0 3 8.083a5.09 5.09 0 0 0 5.083 5.084m10.12 7.545c-.46 0-.92-.175-1.27-.526l-3.81-3.81a1.796 1.796 0 0 1-.495-1.607 8.084 8.084 0 1 1 1.617-1.454 1.792 1.792 0 0 1 1.418.52l3.81 3.81a1.797 1.797 0 0 1-1.27 3.067z"
        />
      </g>
    </svg>
  );
}

Search.propTypes = {
  color: string,
  width: number,
  height: number
};
